<template>
    <div>
        <!--
            占位页：《在线访问产品使用协议》正文素材（头图 + 长图）尚未提供，
            这里先按协议页的骨架占位，不引用任何图片资源，
            拿到素材后只需把 topImgCtn 的背景图与 contentCtn 里的长图补上。
        -->
        <div class="topImgCtn"></div>
        <div class="contentCtn">
            <div class="title">吉林一号在线访问产品使用协议</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MapServiceAgreement"
    }
</script>

<style scoped>
    .contentCtn{
        margin-left:auto;
        margin-right:auto;
        width: 1120px;
        height: auto;
        padding-top:67px;
        padding-bottom: 67px;
    }
    .title{
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3A3A3A;
        text-align: center;
    }
    .topImgCtn{
        position:relative;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 100vw;
        height:40vw;
    }
</style>
